// Ruta directa (no barrel) para evitar ciclo con ui/shared vía DialogMaterialPreview.
import UserList from 'ui/shared/lists/UserList/UserList';
import { Popover } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';

const StudentsGradesDropdownMenu = ({ ariaLabelledBy, users, open, anchorEl, onClose, isScore, scoreScale, evaluationScale }) => {
  // Opcional (TAN-11122): los consumidores que no nombran el panel (VerticalStudentsResults,
  // MaterialPreviewAssignedUsers) conservan el panel sin semántica del Popover.
  const panelA11yProps = ariaLabelledBy ? { ariaLabelledBy, role: 'group' } : {};

  return (
    <div className="dropdown-students-grades">
      <Popover {...panelA11yProps} open={open} anchorEl={anchorEl} handleClose={onClose} className="dropdown-students-grades__lib">
        <div className="dropdown-students-grades__dropdown">
          <UserList
            evaluationScale={evaluationScale}
            users={users}
            showNote={true}
            showPoints={false}
            showCheckbox={false}
            isScore={isScore}
            withBorder={true}
            scoreScale={scoreScale}
          />
        </div>
      </Popover>
    </div>
  );
};

StudentsGradesDropdownMenu.propTypes = {
  anchorEl: PropTypes.object,
  ariaLabelledBy: PropTypes.string,
  evaluationScale: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  isScore: PropTypes.bool,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  scoreScale: PropTypes.number,
  users: PropTypes.array,
};

StudentsGradesDropdownMenu.defaultProps = {
  open: false,
  users: [],
  onClose: () => {},
  anchorEl: {},
  isScore: true,
};

export default StudentsGradesDropdownMenu;
